"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepMerge = void 0;
const isMergeable = (object) => {
    return (typeof object === 'object' && object !== null && !Array.isArray(object));
};
const deepMerge = (target, source) => {
    if (!isMergeable(target) || !isMergeable(source)) {
        return source;
    }
    const result = { ...target };
    for (const key of Object.keys(source)) {
        result[key] = (0, exports.deepMerge)(result[key], source[key]);
    }
    return result;
};
exports.deepMerge = deepMerge;
